<template>
  <div>
    <section class="hero hero-atlantico is-bold">
      <div class="container">
        <div class="hero-body">
          <h1 class="title">Videos</h1>
          <p>Click any of the video cards to see the video.</p>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="container card--atlantico" v-for="(video, index) in videos" :key="video.id">
        <a @click="showVideo(index)">
          <article class="media">
            <figure class="image media-left">
              <img :src="backendURL + video.thumbnail" :alt="video.title">
            </figure>
            <div class="media-content">
              <p class="media-content-title">{{ video.title }}</p>
              <p>{{ video.content }}</p>
            </div>
          </article>
        </a>
      </div>
    </div>

    <app-modal :data="{headerText: videoHeader, type: 'video', src: videoSrc}"></app-modal>
  </div>
</template>

<script>
import AppModal from '../components/AppModal.vue'
export default {
  components: {
    'app-modal': AppModal
  },
  data: function () {
    return {
      videoHeader: '',
      videoSrc: ''
    }
  },
  computed: {
    backendURL () {
      return this.$store.getters.backend_url
    },
    videos () {
      return this.$store.getters.videos
    }
  },
  methods: {
    showVideo (index) {
      let video = this.videos[index]
      this.videoHeader = video.title
      this.videoSrc = this.backendURL
      if (this.$mq !== 'desktop' && video.url_sm) {
        this.videoSrc += video.url_sm
      } else {
        this.videoSrc += video.url_lg
      }
      this.$store.state.modalActive = true
    }
  },
  beforeRouteLeave (to, from, next) {
    // trick to remove the modal when a backbutton is used
    if (this.$store.state.modalActive) {
      // if the modal is active, close it and cancel back navigation
      this.$store.state.modalActive = false
      next(false)
    } else {
      next()
    }
  }
}
</script>
